'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _accessibilityUtils = require('./accessibilityUtils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Tag = function Tag(_ref) {
	var text = _ref.text,
	    onDismiss = _ref.onDismiss;
	return _react2.default.createElement(
		'span',
		{ className: 'tag' },
		_react2.default.createElement(
			'span',
			null,
			text
		),
		_react2.default.createElement('span', {
			className: (0, _classnames2.default)('dismiss', 'gg', 'icon-GG-cross'),
			onClick: onDismiss,
			onKeyPress: function onKeyPress(e) {
				(0, _accessibilityUtils.OnActionKey)(e, onDismiss);
			},
			tabIndex: 0
		})
	);
};
var _default = Tag;
exports.default = _default;
;

var _temp = function () {
	if (typeof __REACT_HOT_LOADER__ === 'undefined') {
		return;
	}

	__REACT_HOT_LOADER__.register(Tag, 'Tag', 'src/components/Tag.jsx');

	__REACT_HOT_LOADER__.register(_default, 'default', 'src/components/Tag.jsx');
}();

;